
      if (!window.__unsupportedBrowser) import("/src/main.js");
    